import React, { Component } from "react";

class GenreRadioButton extends Component {
  render() {
    const { genre, isSelected, select } = this.props;

    return (
      <div
        className={
          isSelected()
            ? "bbe-radio-button-selected"
            : "bbe-button bbe-radio-button"
        }
        onClick={select}
      >
        {genre}
      </div>
    );
  }
}

export default GenreRadioButton;
